import {
  FETCH_ATTENDANCE_DETAILS_REQUEST,
  FETCH_ATTENDANCE_DETAILS_SUCCESS,
  FETCH_ATTENDANCE_DETAILS_FAILURE,
} from "../constants/AttendanceDetailsConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const AttendanceDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ATTENDANCE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_ATTENDANCE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default AttendanceDetailsReducer;
